import { TextBadge } from '@carvana/ds-badge';
import Link from '@carvana/ds-link';
import React from 'react';
import { isCarvanaNativeApp } from '|/helpers/is-native-app';
import { MobileWebviewEvents } from '|/helpers/mobile-webview-events';
import sendNativeEvent from '|/helpers/send-native-event';
import styles from './sections.module.css';
import { isNewVehicle } from '../../../../helpers';

interface VehicleSectionProps {
  vehicle: {
    year?: number;
    make?: string | null;
    model?: string | null;
    trim?: string;
    id?: number;
    primaryImageUrl?: string | null;
    fallbackImageUrl?: string | null;
    offering?: string | null;
  } | null;
}

const VehicleSection: React.FC<VehicleSectionProps> = ({ vehicle }) => {
  if (!vehicle) return null;

  const yearMakeModelText = `${vehicle.year} ${vehicle.make} ${vehicle.model}`;

  const handleViewVehicleDetails = (e: React.MouseEvent) => {
    if (isCarvanaNativeApp() && vehicle.id != null) {
      e.preventDefault();
      sendNativeEvent({
        event: MobileWebviewEvents.CONTINUE_TO_VDP,
        payload: {
          vehicleId: vehicle.id,
          source: 'navigation_rail'
        },
        source: 'purchase'
      });
    }
  };

  return (
    <div className={styles.vehicleHeader}>
      <div className={styles.imageContainer}>
        <img
          className={styles.vehicleImage}
          src={vehicle.primaryImageUrl ?? vehicle.fallbackImageUrl ?? ''}
          alt={yearMakeModelText}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = vehicle.fallbackImageUrl ?? '';
          }}
        />
      </div>
      <div className={styles.vehicleContent}>
        {isNewVehicle(vehicle) && (
          <TextBadge customBgColor="var(--decorative-3-strong)" priority="custom">
            Brand new
          </TextBadge>
        )}
        <div className={styles.vehicleInfo}>
          <h3 className={styles.vehicleTitle}>{yearMakeModelText}</h3>
          <p className={styles.vehicleTrim}>{vehicle.trim}</p>
        </div>
        <div>
          <Link
            href={`/vehicle/${vehicle.id}`}
            className={styles.vehicleDetailsLink}
            data-analytics-id="pp_navrail_vehicle_info"
            data-analytics-id-on-click="pp_navrail_vehicle_info_mobile"
            variant="standalone"
            size="sm"
            onClick={handleViewVehicleDetails}
          >
            View vehicle details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VehicleSection;
